import { httpRequest } from "@services/http";

export interface ResetSegmentDataOptions {
  /** Remove ONLY synthetic is_test rows (safe post-publish). */
  testOnly?: boolean;
  /** Proceed even though closed billing months would be rewritten (MPN-1516).
   *  Deliberately separate from every other option here, so overriding an
   *  invoiced month is never the same click as reprocessing unbilled data.
   *  The server refuses this without a reason, and snapshots the affected
   *  months' invoices before deleting anything. */
  overrideBilledPeriod?: boolean;
  /** Why the override is justified. Required whenever overrideBilledPeriod is
   *  set — it is the audit record for changing an invoiced number. */
  overrideReason?: string;
}

/** Danger Zone "Remove everything" (MPN-1445, MPN-1752): deletes the population's
 *  traces, audience members and membership rows — no replay, published or not.
 *  Definitions, rules, files and network objects stay. Rebuilding is the Files
 *  page's own "Reprocess all files". */
export class CommandResetSegmentData {
  async run(
    populationSegmentId: number,
    options: ResetSegmentDataOptions = {},
  ): Promise<{ job_id: number }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/reset/`;
    return httpRequest<{ job_id: number }>(url, {
      method: "POST",
      body: {
        test_only: options.testOnly ?? false,
        override_billed_period: options.overrideBilledPeriod ?? false,
        override_reason: options.overrideReason ?? "",
      },
    });
  }
}
